import { Card, Table, Button, Pagination, Image } from "react-bootstrap";
import { RiMapPinLine, RiSendPlane2Line, RiFileCopyLine } from "react-icons/ri";
import { useContext, useEffect, useState } from "react";
import { getBookingHistoryAPI, upcomingBookingsAPI } from "../../services/Networkcall";
import { errorAlert } from "../common/Alert";
import CustomPagination from "../common/CustomPagination";
import moment from "moment";
import { Loader } from "../common/Loader";
import BookingDetails from "./BookingDetails";
import { AuthContext } from "../../states/AuthContext";
// import "./GateCodesTable.css";

export default function BookingTable() {

  const { userProfileData } = useContext(AuthContext)
  const [bookings, setBookings] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isTextCopied, setIsTextCopied] = useState(null);
  const [showBookingDetail, setShowBookingDetail] = useState(false);
  const [selectedBookingId, setSelectedBookingId] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1, limit: 10, totalRecords: 1 })
  const [selectedUserId, setSelectedUserId] = useState(userProfileData?._id || "");


  // ==================FETCH ALL BOOKINGS=================
  const fetchBookings = async () => {
    setLoading(true);
    const data = { page: pagination?.page, status: "ALL" }
    try {
      const res = await getBookingHistoryAPI(data);
      if (res?.success) {
        setBookings(res?.data || [])
        setPagination((pre) => ({ ...pre, totalPages: res?.totalNumberOfPages, totalRecords: res?.totalRecords }))
      } else {
        errorAlert({ message: res?.message });
      }
    } catch (err) {
      errorAlert({message: err?.response?.data?.message || err?.message ||  "something went wrong" })
    } finally {
      setLoading(false);
    }
  }

  // ==================FETCH ALL BOOKINGS=================
  const handleShowBookingDetail = (id) => {
    setSelectedBookingId(id)
    setShowBookingDetail(true);
  }

  // ==================HANDLLE PAGINATION=================
  const pageHandler = (page) => {
    setPagination((pre) => ({ ...pre, page: page }));
  }

  // ==================COPY GATE CODE=================
  const CopyGateCode = (gateCode, id) => {
    navigator.clipboard.writeText(gateCode);
    setIsTextCopied(id);
    setTimeout(() => {
      setIsTextCopied(null);
    }, 1000);
  };


  // ==================Effect=================
  useEffect(() => { fetchBookings(); }, [pagination.page])



  return (
    <>
      <Card className="gc-table">
        <Loader show={loading} />
        <div className="table-responsive">
          <Table hover>

            <thead>
              <tr>
                <th>Gate Code</th>
                <th>Driver</th>
                <th>Truck / Plate</th>
                <th>Yard</th>
                <th>Reservation</th>
                <th>Created</th>
                <th>Expires</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {(bookings && bookings?.length > 0) ?
                bookings?.map((item, i) => (
                  <tr key={item._id}>

                    <td data-label="Gate Code" className="gc-code text-primary">
                      {!(item?.uniFiAccessPin) && 'processing...' }
                      {item?.uniFiAccessPin}
                      {item?.uniFiAccessPin && (
                        <>
                          <span className="position-relative d-inline-block">
                            <RiFileCopyLine className="cursor-pointer ms-2 mb-1" onClick={() => CopyGateCode(item?.uniFiAccessPin, item?._id)} />
                            {isTextCopied === item?._id && (
                              <span
                                className="position-absolute bottom-100 start-50 translate-middle-x mb-1 px-2 py-1 rounded bg-dark text-white"
                                style={{ fontSize: "0.75rem", whiteSpace: "nowrap", zIndex: 10 }}
                              >
                                Copied!
                              </span>
                            )}
                          </span>
                        </>
                      )}
                    </td>

                    <td data-label="Driver">
                      <div className="d-flex gap-2">
                        {/* <Image src={item?.driver?.profileImage || "/assets/images/placeholder.png"} rounded width={40} height={40} /> */}
                        <div>
                          <strong>4/10</strong>
                          {/* <strong>{item?.driver?.userName || " "}</strong>
                          <p className="mb-0">{item?.driver?.phoneNumber || " "}</p> */}
                        </div>
                      </div>

                    </td>

                    <td data-label="Truck">
                      <strong>3/10</strong>
                      {/* <strong>{item?.vehicle_info?.vehicleName}</strong>
                      <p className="mb-0">{item?.vehicle_info?.licensePlate}</p> */}
                    </td>

                    <td data-label="Yard">
                      <span className="gc-yard">
                        <RiMapPinLine /> {item.location_info?.locationName}
                      </span>
                    </td>

                    <td data-label="Reservation">
                      {item?.booking_dates && item?.booking_dates?.length > 0 && (
                        <>
                          <p className="mb-0">
                            {moment(item?.booking_dates[0]?.startDateTime).tz(item?.location_info?.location_timezone || moment.tz.guess())
                            .format("MMM DD, hh:mm A")} - </p>
                          <p className="mb-0">{moment(item?.booking_dates[item?.booking_dates?.length - 1]?.endDateTime).tz(item?.location_info?.location_timezone || moment.tz.guess()).format("MMM DD, hh:mm A")}</p>
                        </>
                      ) }
                    </td>

                    <td data-label="Created">
                      {item?.createdAt ? moment(item?.createdAt).tz(item?.location_info?.location_timezone || moment.tz.guess()).format("MMM DD, hh:mm A") : "N/A"}
                    </td>

                    <td data-label="Expires">
                      {item?.booking_dates ? moment(item?.booking_dates[item?.booking_dates?.length - 1]?.endDateTime).tz(item?.location_info?.location_timezone || moment.tz.guess()).format("MMM DD, hh:mm A") : "N/A"}
                    </td>

                    <td data-label="Status">
                      <span className={`gc-status fw-semibold  ${item?.status === "SUCCESS" ? "active" : ""}`}>
                        {item?.status}
                      </span>
                    </td>

                    <td data-label="Action">
                      <Button
                        className="gc-sends px-3" size="sm" variant="outline-primary"
                        onClick={() => { handleShowBookingDetail(item?._id) }}
                      > View
                      </Button>
                    </td>

                  </tr>
                )) : (
                  <tr  >
                    <td colSpan={12} className="text-center py-5">
                      No bookings Found
                    </td>
                  </tr>
                )}
            </tbody>
          </Table>
        </div>


        <CustomPagination
          pagination={pagination}
          pageHandler={pageHandler}
        />
      </Card>
      <BookingDetails show={showBookingDetail} closeModal={() => setShowBookingDetail(false)} bookingId={selectedBookingId} />
    </>
  );
}